export const minifyHtmlString = (html) => {
    return html
        .split('\n')
        .map((s) => s.trim())
        .join('');
};
export const formatFooter = (lines) => {
    return minifyHtmlString(`<div class="so-global-p1">
        ${lines.join('\n')}
      </div>`);
};
export const getClassicFooterHtmlBlocks = (content) => {
    const { dontReply, helpCenter, helpCenterUrl, privacyPolicy, privacyPolicyUrl, termsOfUse, termsOfUseUrl, companyAddressLine, } = content;
    const dontReplyLine = `<p style="line-height: 2.1em; text-align: center;font-size: 13px" class="so-global-p1">
          <span style="color: #2D2D2D">
            <span style="font-size: 13px">
              <span style="line-height: 2.1em">${dontReply}</span>
            </span>
          </span>
        </p>`;
    const addressLine = ` <p style="line-height: 2.1em;text-align: center; font-size: 13px" class="so-global-p1">
          <span style="color: #2D2D2D">
            <span style="font-size: 13px">
              <span style="line-height: 2.1em; color: #2D2D2D;">${companyAddressLine}</span>
            </span>
          </span>
        </p>`;
    const linksLine = ` <p style="line-height: 2.1em; text-align: center;font-size: 13px" class="so-global-p1">
          <a target="_blank" rel="noopener noreferrer" href="${helpCenterUrl}">
            <span style="color: #2D2D2D">
              <span style="font-size: 13px">
                <span style="text-decoration: underline">
                  <span style="line-height: 2.1em;border-right: 1px solid #2d2d2d;padding-right: 8px;">${helpCenter}</span>
                </span>
              </span>
            </span>
          </a>
          <a target="_blank" rel="noopener noreferrer" href="${privacyPolicyUrl}">
            <span style="color: #2D2D2D">
              <span style="font-size: 13px">
                <span style="text-decoration: underline">
                  <span style="line-height: 2.1em;border-right: 1px solid #2d2d2d;padding-right: 8px;padding-left: 8px;">${privacyPolicy}</span>
                </span>
              </span>
            </span>
          </a>
          <a target="_blank" rel="noopener noreferrer" href="${termsOfUseUrl}">
            <span style="color: #2D2D2D">
              <span style="font-size: 13px">
                <span style="text-decoration: underline">
                  <span style="line-height: 2.1em;padding-left: 8px;">${termsOfUse}</span>
                </span>
              </span>
            </span>
          </a>
        </p>`;
    return { addressLine, linksLine, dontReplyLine };
};
//# sourceMappingURL=utils.js.map